import React from 'react';
import {IProps} from './types';
import * as S from './styles';
import RemoveIconWhite from '@assets/icons/removeIconWhite';

const Chips:React.FC<IProps> = (props) => {

  return (
    <S.Root>
      {
        props.items.map((item: string, index:number) => {
          return (
            <S.ChipContainer key={index} >
              {item}
              <S.RemoveIconContainer onClick={() => props.handleRemove(index, props.id)} >
                <RemoveIconWhite />
              </S.RemoveIconContainer>
            </S.ChipContainer>
          )
        })
      }
    </S.Root>
  );
}

export default Chips;